"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBCModule = void 0;
const tx_1 = require("../codec/ibc/applications/transfer/v1/tx");
const constant_1 = require("../constant");
const provider_1 = require("../provider");
const util_1 = require("../util");
const long_1 = __importDefault(require("long"));
const base_1 = __importDefault(require("./base"));
class IBCModule extends base_1.default {
    /** @deprecated please use sendIbcTransferUpdated instead */
    sendIBCTransfer(params, msgOpts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            if (!params.revisionHeight) {
                const lastHeight = yield this.sdkProvider.query.chain.getHeight();
                // Set the timeout height as the current height + 150.
                params.revisionHeight = (lastHeight !== null && lastHeight !== void 0 ? lastHeight : 0) + 150;
            }
            const value = tx_1.MsgTransfer.fromPartial(Object.assign({ sourcePort: params.sourcePort, sourceChannel: params.sourceChannel, token: {
                    denom: params.denom,
                    amount: params.amount.toString(10),
                }, sender: (_a = params.sender) !== null && _a !== void 0 ? _a : wallet.bech32Address, receiver: params.receiver, timeoutHeight: {
                    revisionHeight: params.revisionHeight,
                    revisionNumber: (_b = params.revisionNumber) !== null && _b !== void 0 ? _b : 1,
                } }, (params.timeoutTimestamp && {
                timeoutTimestamp: params.timeoutTimestamp,
            })));
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgTransfer,
                value,
            }, msgOpts);
        });
    }
    sendIbcTransferV2(params, msgOpts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgTransfer.fromPartial(Object.assign(Object.assign({ sourcePort: params.sourcePort, sourceChannel: params.sourceChannel, token: {
                    denom: params.denom,
                    amount: params.amount.toString(10),
                }, sender: (_a = params.sender) !== null && _a !== void 0 ? _a : wallet.bech32Address, receiver: params.receiver }, params.timeoutHeight && ({
                timeoutHeight: {
                    revisionHeight: new long_1.default(params.timeoutHeight.revisionHeight.toNumber()),
                    revisionNumber: new long_1.default(params.timeoutHeight.revisionNumber.toNumber()),
                },
            })), params.timeoutTimestamp && ({
                timeoutTimestamp: params.timeoutTimestamp.toNumber(),
            })));
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgTransfer,
                value,
            }, msgOpts);
        });
    }
    getChainInfoMap(denomTraces = {}) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            const tokenClient = this.sdkProvider.getTokenClient();
            const ibcBridges = tokenClient.bridges.ibc;
            const chainsResponse = yield fetch(`https://chains.cosmos.directory/`);
            const chainsData = yield chainsResponse.json();
            const chainInfoMap = {};
            for (let ibc = 0; ibc < ibcBridges.length; ibc++) {
                const ibcBridge = ibcBridges[ibc];
                const chainId = ibcBridge.chain_id_name;
                const chainName = (_b = (_a = ibcBridge.chain_id_name.match(constant_1.ibcNetworkRegex)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : "";
                const chainData = chainsData.chains.find((d) => d.chain_id === chainId);
                let chainInfo = yield this.getChainInfo(chainName);
                if (chainInfo === undefined) {
                    const fallbackChainInfo = yield this.getAssembledChainInfo(chainId, chainData);
                    chainInfo = fallbackChainInfo;
                }
                if (chainInfo) {
                    chainInfoMap[ibcBridge.chain_id_name] = Object.assign(Object.assign({}, chainInfo), { minimalDenomMap: {}, bestRpcs: (_c = chainData === null || chainData === void 0 ? void 0 : chainData.best_apis.rpc) !== null && _c !== void 0 ? _c : [] });
                }
            }
            const carbonChainInfo = yield provider_1.KeplrAccount.getChainInfo(this.sdkProvider);
            if (carbonChainInfo) {
                chainInfoMap[carbonChainInfo.chainId] = Object.assign(Object.assign({}, carbonChainInfo), { minimalDenomMap: {}, bestRpcs: [] });
            }
            for (const key in denomTraces) {
                const denomTrace = denomTraces[key];
                const denom = util_1.IBCUtils.makeIBCMinimalDenom(denomTrace.path, denomTrace.baseDenom);
                const token = tokenClient.tokenForDenom(denom);
                if (!token)
                    continue;
                const isChainNativeToken = denomTrace.path.split("/").length === 2;
                const chainId = tokenClient.getIbcChainIdFromToken(token);
                if (chainId && chainInfoMap[chainId]) {
                    const cw20RegexArr = denomTrace.baseDenom.match(constant_1.cw20TokenRegex);
                    const coinGeckoId = (_g = (_e = (_d = tokenClient.geckoTokenNames) === null || _d === void 0 ? void 0 : _d[denom]) !== null && _e !== void 0 ? _e : (_f = tokenClient.geckoTokenNames) === null || _f === void 0 ? void 0 : _f[denomTrace.baseDenom]) !== null && _g !== void 0 ? _g : "";
                    const dstDenom = isChainNativeToken ? denomTrace.baseDenom.replace(/:/g, '/') : util_1.IBCUtils.makeIBCMinimalDenom(denomTrace.path.replace(constant_1.ibcTransferChannelRegex, "").replace(/^\//, ''), denomTrace.baseDenom);
                    const currency = this.getAppCurrency(dstDenom, coinGeckoId, token, cw20RegexArr);
                    const chainInfo = chainInfoMap[chainId];
                    chainInfo.currencies.push(currency);
                    chainInfo.minimalDenomMap[token.denom] = dstDenom;
                }
            }
            return chainInfoMap;
        });
    }
    getAppCurrency(coinMinimalDenom, coinGeckoId, tokenInfo, cw20RegexArr) {
        var _a, _b, _c;
        const appCurrency = Object.assign({ coinDenom: (_a = tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol) !== null && _a !== void 0 ? _a : "", coinMinimalDenom: coinMinimalDenom, coinDecimals: (_b = tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals.toNumber()) !== null && _b !== void 0 ? _b : 0, coinGeckoId: coinGeckoId }, (cw20RegexArr === null || cw20RegexArr === void 0 ? void 0 : cw20RegexArr.length) && ({
            type: "cw20",
            contractAddress: (_c = cw20RegexArr[1]) !== null && _c !== void 0 ? _c : "",
        }));
        return appCurrency;
    }
    getChainInfo(chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!chainName)
                return undefined;
            const chainInfoResponse = yield fetch(`https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/master/cosmos/${chainName}.json`);
            if (!chainInfoResponse.ok) {
                if (chainInfoResponse.status === 404) {
                    return undefined;
                }
            }
            const chainInfoJson = yield chainInfoResponse.json();
            return chainInfoJson;
        });
    }
    getAssembledChainInfo(chainId, chainData) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const defaultChainInfo = util_1.IBCUtils.EmbedChainInfos[chainId];
            if (chainData) {
                try {
                    const chainInfoResponse = yield fetch(`https://raw.githubusercontent.com/cosmos/chain-registry/master/${chainData.chain_name}/chain.json`);
                    const chainInfoJson = yield chainInfoResponse.json();
                    const chainAssetListResponse = yield fetch(`https://raw.githubusercontent.com/cosmos/chain-registry/master/${chainData.chain_name}/assetlist.json`);
                    const assetListJson = yield chainAssetListResponse.json();
                    const features = [];
                    if (chainData.cosmwasm_enabled) {
                        features.push("cosmwasm");
                    }
                    // Extract the staking currency denomination from chainInfoJson (min. denom)
                    const stakingCurrencyDenom = ((_b = (_a = chainInfoJson.staking.staking_tokens) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.denom) || '';
                    // Find the asset that matches the stakingCurrencyDenom
                    const stakingAsset = assetListJson.assets.find((asset) => {
                        return asset.denom_units.some((unit) => unit.denom === stakingCurrencyDenom);
                    });
                    // Find the highest denom unit
                    const maxExponentDenomUnit = stakingAsset.denom_units.reduce((prev, current) => {
                        return (prev.exponent > current.exponent) ? prev : current;
                    });
                    const stakeCurrency = {
                        coinDenom: maxExponentDenomUnit.denom.toUpperCase(),
                        coinMinimalDenom: stakingCurrencyDenom,
                        coinDecimals: maxExponentDenomUnit.exponent,
                        coinGeckoId: (_c = stakingAsset === null || stakingAsset === void 0 ? void 0 : stakingAsset.coingecko_id) !== null && _c !== void 0 ? _c : '',
                    };
                    const currencies = assetListJson.assets.map((asset) => {
                        // Find the denom_unit with the maximum exponent
                        const maxExponentDenomUnit = asset.denom_units.reduce((prev, current) => {
                            return (prev.exponent > current.exponent) ? prev : current;
                        });
                        return {
                            coinDenom: maxExponentDenomUnit.denom.toUpperCase(),
                            coinMinimalDenom: asset.base,
                            coinDecimals: maxExponentDenomUnit.exponent,
                            coinGeckoId: asset.coingecko_id,
                        };
                    });
                    // Filter out fee tokens which do not have a corresponding asset
                    const validFeeTokens = chainInfoJson.fees.fee_tokens.filter((feeToken) => {
                        const correspondingAsset = assetListJson.assets.find((asset) => asset.base === feeToken.denom);
                        return correspondingAsset !== undefined;
                    });
                    const feeCurrencies = validFeeTokens.map((feeToken) => {
                        // Find the corresponding asset for the fee token
                        const correspondingAsset = assetListJson.assets.find((asset) => asset.base === feeToken.denom);
                        // Find the denom_unit with the maximum exponent
                        const maxExponentDenomUnit = correspondingAsset.denom_units.reduce((prev, current) => {
                            return (prev.exponent > current.exponent) ? prev : current;
                        });
                        return {
                            coinDenom: maxExponentDenomUnit.denom.toUpperCase(),
                            coinMinimalDenom: feeToken.denom,
                            coinDecimals: maxExponentDenomUnit.exponent,
                            coinGeckoId: correspondingAsset.coingecko_id,
                            gasPriceStep: {
                                low: feeToken.low_gas_price,
                                average: feeToken.average_gas_price,
                                high: feeToken.high_gas_price,
                            },
                        };
                    });
                    return {
                        rpc: (_d = defaultChainInfo.rpc) !== null && _d !== void 0 ? _d : chainInfoJson.apis.rpc[0].address,
                        rest: (_e = defaultChainInfo.rest) !== null && _e !== void 0 ? _e : chainInfoJson.apis.rest[0].address,
                        chainId: chainInfoJson.chain_id,
                        chainName: chainInfoJson.chain_name,
                        bip44: {
                            coinType: chainInfoJson.slip44,
                        },
                        bech32Config: constant_1.IBCAddress.defaultBech32Config(chainInfoJson.bech32_prefix),
                        stakeCurrency: stakeCurrency,
                        currencies: currencies,
                        feeCurrencies: feeCurrencies,
                        features: [
                            "ibc-transfer",
                            "ibc-go",
                        ],
                    };
                }
                catch (error) {
                    return defaultChainInfo;
                }
            }
            else {
                return defaultChainInfo;
            }
        });
    }
}
exports.IBCModule = IBCModule;
